import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL, PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkIfPruefAssitenzNeedsToValidate } from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
const P = AntragSchema.attributes;

const AusgangssituationEmobLis: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Ausgangssituation' description={PLATZHALTER_TEXT} />

			<PruefAssistenz
				statusPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0030170675_tuation_Pruefung_Pruefstatus.path
				}
				hinweisPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0045031698_nweis_Fuer_Den_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0244197901_on_Pruefung_Ueberarbeitet_Am.path
				}
				erledigtPath={
					P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0231697972_ssituation_Pruefung_Erledigt.path
				}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default AusgangssituationEmobLis;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0231697972_ssituation_Pruefung_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0020508766_ntragstellenden_Organisation,
				P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0231778135_Vor_Ort_Und_In_Der_Umgebung,
				P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0018662631_Einer_Staatlichen_Foerderung,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucAusgangssituationEmobLis = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0030170675_tuation_Pruefung_Pruefstatus.path,
			P.Projektbeschreibung_Elektromobilitaet_LIS.schema.attributes.Projektbeschreibung_Elek_0231697972_ssituation_Pruefung_Erledigt.path,
		)
	) {
		return concat(formStrucPruefAssistenz(), formStruc());
	} else return concat(formStruc());
};
